import { DiscussSearchFilter } from '../../api/public/discuss-api';
import { i18n } from '../../symphony';

export const SlDiscussContext = 'mf_slDiscuss_context';

export enum RepliesOrderType {
	Vote = 1,
	Date = 2,
}

export const getQuestionsFilerType = () => ({
	[DiscussSearchFilter[5]]: i18n.t('web-discuss.filter-trending'),
	[DiscussSearchFilter[1]]: i18n.t('web-discuss.filter-most-recent'),
	[DiscussSearchFilter[8]]: i18n.t('web-discuss.filter-unanswered'),
	[DiscussSearchFilter[6]]: i18n.t('web-discuss.filter-my-questions'),
	[DiscussSearchFilter[7]]: i18n.t('web-discuss.filter-my-answers'),
});

export const questionsFilerTypeAlias = {
	[DiscussSearchFilter[5]]: 'Trending',
	[DiscussSearchFilter[1]]: 'MostRecent',
	[DiscussSearchFilter[8]]: 'Unanswered',
	[DiscussSearchFilter[6]]: 'MyQuestions',
	[DiscussSearchFilter[7]]: 'MyAnswers',
};

export const questionsFilerTrackingType = {
	[DiscussSearchFilter[5]]: 'TRENDING',
	[DiscussSearchFilter[1]]: 'MOST_RECENT',
	[DiscussSearchFilter[8]]: 'UNANSWERED',
	[DiscussSearchFilter[6]]: 'MY_QUESTIONS',
	[DiscussSearchFilter[7]]: 'MY_ANSWERS',
};

export const REPLIES_COUNT_BY_PAGE = 50;

export const HOT_TODAY_QUESTIONS_COUNT = 10;

export const QUESTIONS_LIST_COUNT = 50;

export const getSelectBestAnswerMessage = () => i18n.t('web-discuss.pick-as-best-answer-notification');

export const getUnselectBestAnswerMessage = () => i18n.t('web-discuss.unpick-best-answer-notification');

export const getAddAnswerMessage = () => i18n.t('web-discuss.new-answer-post-notification');
export const getEditAnswerMessage = () => i18n.t('web-discuss.update-answer-notification');

export const getBackendErrorMessages = () => ({
	258: i18n.t('web-discuss.activate-account-warning'),
	2: i18n.t('web-discuss.activate-account-warning'),
	257: i18n.t('web-discuss.more-xp-needed-warning'),
});

export const getRecomendedCourseInfo = () => ({
	TITLE: i18n.t('web-discuss.recomended-courses-title'),
	SUB_TITLE: i18n.t('web-discuss.recomended-courses-subtitle'),
	TOP_COURSES: [
		{
			title: i18n.t('web-discuss.recomended-course1-title'),
			desc: i18n.t('web-discuss.recomended-course1-desc'),
			imageSource:
                'https://lecontent.sololearn.com/material-images/d7aa9e6be90c47c3968f99d1a30792e1-Python For Beginners.png',
			alias: 'python-introduction',
		},
		{
			title: i18n.t('web-discuss.recomended-course2-title'),
			desc: i18n.t('web-discuss.recomended-course2-desc'),
			imageSource:
                'https://lecontent.sololearn.com/material-images/bdee16064033400b8cf3986c7ac1b569-Introduction to Java.png',
			alias: 'java-introduction',
		},
		{
			title: i18n.t('web-discuss.recomended-course3-title'),
			desc: i18n.t('web-discuss.recomended-course3-desc'),
			imageSource:
                'https://lecontent.sololearn.com/material-images/826fc066921946f78912fe0e06f08f01-C Track Introduction.png',
			alias: 'c-introduction',
		},

		{
			title: i18n.t('web-discuss.recomended-course4-title'),
			desc: i18n.t('web-discuss.recomended-course4-desc'),
			imageSource:
                'https://lecontent.sololearn.com/material-images/0a6fa781db4f41f39f009cb1a75662b3-1014.png',
			alias: 'html-introduction',
		},
	],
	CTA: {
		LINK: '/learn',
		TEXT: i18n.t('web-discuss.recomended-courses-cta'),
	},
});
